import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/blog/ivd-use-in-eu-clinical-trials")({
  head: () => buildRouteHead("/es/blog/ivd-use-in-eu-clinical-trials", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ href: "/en/blog/ivd-use-in-eu-clinical-trials", replace: true });
  },
});
